import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18nHelper from "@/core/services/i18n.service";
import {Formatter} from "@/core/services/formatter.service";

export default class ServiceInvoiceModel extends BaseModel {
  uuid = null;
  customer_uuid = null;
  shipping_address_uuid = null;
  is_exported = null;
  is_tax_applied = null;
  is_registered_business = null;
  enable_shipping = false;
  shipping_amount = null;
  shipping_vat = null;
  shipping_taxable = null;
  preferred_language_code = null;
  complaint_status = null;
  shipping_tracking_code = null;
  tax_rate = null;
  miscellaneous_items = [];
  date = Formatter.getCurrentDate();
  exclude_from_auto_payments = null;
  static TRANSLATABLE_FIELDS = [];
  invoice_billing_address = null;
  invoice_shipping_address = null;

  rules = {
    customer_uuid: 'required',
    preferred_language_code: 'required',
  };

  attributeLabels = {
    customer_uuid: i18n.t('Customer'),
    shipping_address_uuid: i18n.t('Shipping Address'),
    is_exported: i18n.t('Exported'),
    is_tax_applied: i18n.t('Apply VAT'),
    is_registered_business: i18n.t('Exported outside EU'),
    preferred_language_code: i18n.t('Preferred Language'),
    complaint_status: i18n.t('Complaint Status'),
    tax_rate: i18n.t('Tax Rate'),
    date: i18n.t('Date'),
    exclude_from_auto_payments: i18n.t('Exclude from Auto-Payments'),
  };

  attributeHints = {
    preferred_language_code: i18n.t('Invoice template will be created according to the selected language'),
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;
  }
}
